import api from "../../utils/api";

export const state = {
  _premiumReportInfo: null,
  _premiumMonitoringList: [],
  _premiumMonitoringPage: {
    total: 0,
    page: 1,
    limit: 20,
  },
};

export const mutations = {
  setPremiumReportInfo(state, data) {
    state._premiumReportInfo = data;
  },
  clearPremiumReportInfo(state) {
    state._premiumReportInfo = null;
  },
  setPremiumMonitoringList(state, data) {
    state._premiumMonitoringList = data.items;
    state._premiumMonitoringPage = {
      total: data.total,
      page: data.page,
      limit: data.limit,
    };
  },
};

export const actions = {
  async acGetPremiumMonitoringList({ commit }, { page, limit, email }) {
    const url = `/api/v1/subscribe-premium/monitoring-list`;
    try {
      const params = { page, limit };
      if (email) {
        params.email = email;
      }
      const res = await api.get(url, { params });
      console.log("프리미엄 모니터링 목록", res.data);

      if (res.data.statusCode === 200) {
        commit("setPremiumMonitoringList", res.data.data);
        return res.data.data;
      }
      return null;
    } catch (e) {
      console.error("프리미엄 모니터링 목록 조회 실패", e);
      return null;
    }
  },
  async acGetPremiumReportInfoByAnalyzeSeq({ commit }, analyze_seq) {
    const url = `/api/v1/subscribe-premium/report-info/analyze/${analyze_seq}`;
    try {
      const res = await api.get(url);
      console.log("프리미엄매매리포트 정보 (analyze_seq)", res.data);

      if (res.data.statusCode === 200) {
        commit("setPremiumReportInfo", res.data.data);
        return res.data.data;
      }
      return null;
    } catch (e) {
      console.error("프리미엄매매리포트 정보 조회 실패 (analyze_seq)", e);
      commit("clearPremiumReportInfo");
      return null;
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
